import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal, Eyebrow } from "./Reveal";
import { SITE } from "../config/site";

const FAQS = [
  {
    q: "What is play-based therapy?",
    a: "Children rarely sit and talk about feelings — they play them out. In play-based therapy, toys, stories, art and games become a safe language. Through play, children express worries, practise coping and build emotional skills, all while simply feeling like they're having fun.",
  },
  {
    q: "Do you offer online sessions? How do they work for children?",
    a: "Yes — sessions are available online and in-person. Online child sessions are interactive and play-led (I guide activities that you set up easily at home), while parent and adult sessions work beautifully over a simple video call.",
  },
  {
    q: "Are you really verified at Mantra Care?",
    a: "Yes. I practise as a verified psychologist on the Mantra Care platform, and you can cross-check my credentials on my Mantra Care profile — the link is in the About section and header of this site.",
  },
  {
    q: "What ages and issues do you work with?",
    a: "Children (roughly 3–14) for development, behaviour and big emotions; teenagers and adults for anxiety, stress, self-growth and work burnout; and couples or whole families for conflict and communication.",
  },
  {
    q: "What is the cancellation policy?",
    a: "Life happens — sessions can be rescheduled free of charge up to 12 hours in advance. Cancellations within 12 hours are charged at 50%, so the slot can be planned fairly for everyone.",
  },
];

export default function Faq() {
  return (
    <section id="faq" data-testid="faq-section" className="bg-[#F7F4EB] py-20 lg:py-28">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-4 sm:px-8 lg:grid-cols-12 lg:gap-20 lg:px-16">
        <Reveal className="lg:col-span-5">
          <Eyebrow>Questions, answered</Eyebrow>
          <h2 className="mt-4 font-serif text-3xl font-medium leading-snug tracking-tight text-[#064E3B] sm:text-4xl lg:text-5xl">
            Everything you&rsquo;re <em className="text-[#059669]">wondering</em>, gently answered
          </h2>
          <p className="mt-5 max-w-md text-base leading-relaxed text-[#526560]">
            Still unsure about something? Send a message through the form below or WhatsApp — I
            personally reply to every enquiry.
          </p>
          <a
            href={SITE.mantraCareUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="faq-mantra-care-link"
            className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-[#059669] underline-offset-4 hover:underline"
          >
            Verify my Mantra Care profile
          </a>
        </Reveal>
        <Reveal delay={0.12} className="lg:col-span-7">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`item-${i}`}
                data-testid="faq-item"
                className="border-b border-[#064E3B]/12"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="py-5 text-left font-serif text-lg font-medium text-[#064E3B] hover:text-[#059669] hover:no-underline sm:text-xl"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-sm leading-relaxed text-[#526560] sm:text-base">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
